import { type IPopupHelperProps, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderRequiredSignUpDialogData = (params: Omit<IPopupHelperProps, 'popupName'>) =>
    openPopupHelper({ popupName: popupNames.MOBILE_REQUIRED_SIGNUP, ...params });
